/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type OrgSettingsQueryVariables = {};
export type OrgSettingsQueryResponse = {
    readonly viewer: {
        readonly id: string;
        readonly user: {
            readonly orgs: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly " $fragmentRefs": FragmentRefs<"OrgSettings_org">;
                    } | null;
                } | null> | null;
            };
            readonly " $fragmentRefs": FragmentRefs<"OrgSettings_user">;
        } | null;
    };
};
export type OrgSettingsQuery = {
    readonly response: OrgSettingsQueryResponse;
    readonly variables: OrgSettingsQueryVariables;
};



/*
query OrgSettingsQuery {
  viewer {
    id
    user {
      ...OrgSettings_user
      orgs(first: 1000000) {
        edges {
          node {
            ...OrgSettings_org
            id
          }
        }
      }
      id
    }
  }
}

fragment AvatarPerson_org on Org {
  id
}

fragment AvatarPerson_orgPerson on OrgPerson {
  __typename
  id
  primaryCalendarId
  isYou
  userId
  profile {
    givenName
    familyName
    externalImageUrl
  }
}

fragment AvatarRowNew_org on Org {
  ...AvatarPerson_org
}

fragment OrgSettings_org on Org {
  id
  domains
  primaryOrgCalendar
  ...ZoomSettings_org
  ...AvatarRowNew_org
  currentOrgPersons {
    __typename
    ... on OrgPersonList {
      list {
        ...AvatarPerson_orgPerson
        primaryCalendarId
        userId
        personId
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
        id
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment OrgSettings_user on User {
  ...ZoomSettings_user
}

fragment ZoomSettings_org on Org {
  id
  zoomAccount {
    __typename
    ... on GraphEntityError {
      message
      statusCode
    }
    ... on ZoomAccount {
      accountId
      connected
      displayName
      ownerUserId
      ownerPersons {
        __typename
        ... on GraphEntityError {
          message
          statusCode
        }
        ... on PersonList {
          list {
            primaryEmail
            isYou
            profile {
              givenName
              familyName
              externalImageUrl
            }
            id
          }
        }
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment ZoomSettings_user on User {
  id
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v5 = {
        "kind": "InlineFragment",
        "selections": [
            (v3 /*: any*/),
            (v4 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isYou",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "givenName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "familyName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalImageUrl",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "OrgSettingsQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v1 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": null,
                                                            "kind": "FragmentSpread",
                                                            "name": "OrgSettings_org"
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "OrgSettings_user"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "OrgSettingsQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v1 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v0 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "domains",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "primaryOrgCalendar",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "zoomAccount",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v5 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "accountId",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "connected",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "displayName",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "ownerUserId",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": null,
                                                                            "kind": "LinkedField",
                                                                            "name": "ownerPersons",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                (v5 /*: any*/),
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "Person",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "list",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "primaryEmail",
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                (v6 /*: any*/),
                                                                                                (v7 /*: any*/),
                                                                                                (v0 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "type": "PersonList",
                                                                                    "abstractKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "ZoomAccount",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v0 /*: any*/)
                                                                    ],
                                                                    "type": "Node",
                                                                    "abstractKey": "__isNode"
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "currentOrgPersons",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "OrgPerson",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                (v0 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "primaryCalendarId",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v6 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "userId",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v7 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "personId",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "OrgPersonList",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v4 /*: any*/),
                                                                        (v3 /*: any*/)
                                                                    ],
                                                                    "type": "GraphEntityError",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "b09866702a26bf1f7c3eb787f81853be",
            "id": null,
            "metadata": {},
            "name": "OrgSettingsQuery",
            "operationKind": "query",
            "text": "query OrgSettingsQuery {\n  viewer {\n    id\n    user {\n      ...OrgSettings_user\n      orgs(first: 1000000) {\n        edges {\n          node {\n            ...OrgSettings_org\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment AvatarPerson_org on Org {\n  id\n}\n\nfragment AvatarPerson_orgPerson on OrgPerson {\n  __typename\n  id\n  primaryCalendarId\n  isYou\n  userId\n  profile {\n    givenName\n    familyName\n    externalImageUrl\n  }\n}\n\nfragment AvatarRowNew_org on Org {\n  ...AvatarPerson_org\n}\n\nfragment OrgSettings_org on Org {\n  id\n  domains\n  primaryOrgCalendar\n  ...ZoomSettings_org\n  ...AvatarRowNew_org\n  currentOrgPersons {\n    __typename\n    ... on OrgPersonList {\n      list {\n        ...AvatarPerson_orgPerson\n        primaryCalendarId\n        userId\n        personId\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n        id\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment OrgSettings_user on User {\n  ...ZoomSettings_user\n}\n\nfragment ZoomSettings_org on Org {\n  id\n  zoomAccount {\n    __typename\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n    ... on ZoomAccount {\n      accountId\n      connected\n      displayName\n      ownerUserId\n      ownerPersons {\n        __typename\n        ... on GraphEntityError {\n          message\n          statusCode\n        }\n        ... on PersonList {\n          list {\n            primaryEmail\n            isYou\n            profile {\n              givenName\n              familyName\n              externalImageUrl\n            }\n            id\n          }\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment ZoomSettings_user on User {\n  id\n}\n"
        }
    } as any;
})();
(node as any).hash = 'da7d591a55cbd45ec0fb9cc621cc48d1';
export default node;
